import { translate } from "@jsverse/transloco";
import { CustomColumnService } from "../../contract-control/custom-column-service/custom-column.service";
import { documentPreviewColumns } from "../../documents/document-right-sidebar/custom-columns";
import { MetaDataTypeEnum } from "./metadata-item.dto";

export enum MetaDataSectionEnum {
  DOCUMENT_FIELD = "document_field",
  CONTRACT_FIELD = "contract_field",
  PERSON_FIELD = "person_field",
  ORGANIZATION_FIELD = "org_field",
  USER_FIELD = "user_field",
  PRODUCT_FIELD = "product_field",
  INDEX_FIELD = "index_field",
}

export function sections() {
  return [
    {
      value: "",
      label: translate(
        "Filter default selected item - (general) - All"
      ),
    },
    {
      value: "document_field",
      label: translate("Meta data field section droplist option - (Meta data section) - Document field"),
    },
    {
      value: "person_field",
      label: translate(
        "Meta data field section droplist option - (Meta data section) - Person field"
      ),
    },
    {
      value: "org_field",
      label: translate(
        "Meta data field section droplist option - (Meta data section) - Organization field"
      ),
    },
    {
      value: "user_field",
      label: translate(
        "Meta data field section droplist option - (Meta data section) - User field"
      ),
    },
    {
      value: "product_field",
      label: translate(
        "Meta data field section product field - (Meta data section) - Product field"
      ),
    },
    {
      value: "index_field",
      label: translate(
        "Meta data field section droplist option - (Meta data section) - Index field"
      ),
    }
  ];
}

export function getContractSectionFields(
  customColumnService$: CustomColumnService
) {
  return customColumnService$.getCustomColumns()?.map((item) => ({
    id: 0,
    api_attribute: item?.field_name,
    created_at: "",
    is_required: 0 as const,
    meta_data_description: "",
    meta_data_name: item?.label,
    meta_data_option: [],
    meta_data_type: MetaDataTypeEnum.text,
    section: "standard_field",
    source: "Simple sign",
    multi_select: 0,
    updated_at: "",
    user_id: 0,
    disabled: false,
    workspace_id: 0,
  }));
}



export function getDocumentSectionFields() {
  const documentCustomColumns = [...documentPreviewColumns];
  return documentCustomColumns?.map((item) => ({
    id: 0,
    api_attribute: item?.field_name,
    created_at: "",
    is_required: 0 as const,
    meta_data_description: "",
    meta_data_name: item?.label,
    meta_data_option: [],
    meta_data_type: MetaDataTypeEnum.text,
    section: "standard_field",
    source: "Simple sign",
    multi_select: 0,
    updated_at: "",
    user_id: 0,
    disabled: false,
    workspace_id: 0
  }));
}

